import {
	ADD_IMPORT_SECTOR,
	GET_ALL_RETAILER,
	ADD_IMPORT_KPI,
	IMPORT_FILE,
	GET_ALL_CLIENT,
	ADD_IMPORT_ASSORTMENTS,
	ADD_IMPORT_CLIENT,
} from "./../types";
import {
	importApiUpsellProvider,
	retailersApiUpsellProvider,
	kpiApiUpsellProvider,
	clientsApiProvider,
	assortmentApiUpsellProvider,
} from "./../../lib/api/providers";

export const addmportAssortiment = body => {
	return {
		prefixType: ADD_IMPORT_CLIENT,
		callAPI: () => assortmentApiUpsellProvider.post(`importAssortment`, body),
	};
};

export const addImportAssortments = body => {
	return {
		prefixType: ADD_IMPORT_ASSORTMENTS,
		callAPI: () => importApiUpsellProvider.post(`assortments`, body),
	};
};

export const getAllClients = () => {
	return {
		prefixType: GET_ALL_CLIENT,
		callAPI: () => clientsApiProvider.get(`findAll`),
	};
};

export const importFile = (uri, body) => {
	return {
		prefixType: IMPORT_FILE,
		callAPI: () => importApiUpsellProvider.post(uri, body),
	};
};

export const addmportKpi = body => {
	return {
		prefixType: ADD_IMPORT_KPI,
		callAPI: () => kpiApiUpsellProvider.post(`importKpis`, body),
	};
};

export const addImportSector = body => {
	return {
		prefixType: ADD_IMPORT_SECTOR,
		callAPI: () => importApiUpsellProvider.post(`secto`, body),
	};
};

export const getAllRetailers = () => {
	return {
		prefixType: GET_ALL_RETAILER,
		callAPI: () => retailersApiUpsellProvider.get(`findAll`),
	};
};



// WEBPACK FOOTER //
// src/redux/actions/clientActions.js